import { Step } from "react-joyride";

/**
 * Guided tour steps for the Evaluation Panel step.
 *
 * Each step targets a `data-testid` attribute rendered in the step.
 * If a target isn't present (e.g. panel mode not selected), Joyride will auto-skip it.
 */
export const evaluationPanelSteps: Step[] = [
	{
		target: '[data-testid="panel-mode-solo"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Evaluation Mode</h3>
				<p>
					Choose how you want to evaluate submissions. You can score
					everything yourself or assemble a panel of evaluators.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="add-member-form"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Add Panel Members</h3>
				<p>
					Add members to the panel either from your organisation or as
					external members. Search by name to add a colleague from your
					organisation, or enter an email address to invite an external member.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="panel-members-table"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Panel Members</h3>
				<p>
					Once your list is created, you can send invitations to all panel
					members at once so they can begin their evaluations.
				</p>
				<p className="mt-2 text-gray-500">
					When members accept their invitations, they appear here along with
					their current statuses so you can track who has joined the panel.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="proceed-invitations-btn"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Send Invitations</h3>
				<p>
					Once you&apos;ve added all panel members, send invitations to the
					whole list so they can begin their evaluations. You can also continue
					without sending and invite later.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
];
